export default function BgVideo({ src }) {
  return (
    <div className="bg-video">
      <video autoPlay loop muted playsInline>
        <source src={src} type="video/mp4" />
      </video>
    </div>
  );
}